
const tableActions = {
  ADD_VISIBLE_COLUMNS:'ADD_VISIBLE_COLUMNS',
  CLEAR_VISIBLE_COLUMNS:'CLEAR_VISIBLE_COLUMNS',
  
  addVisibleColumns: (columns) => ({
    type: tableActions.ADD_VISIBLE_COLUMNS,
    columns,
  }),
  clearVisibleColumns: () => ({
    type: tableActions.CLEAR_VISIBLE_COLUMNS,
  }),
};

export default tableActions;
